import React from 'react';

import Placeholder from 'components/consumer/Placeholder';

const PDPShopTabsBarPlaceholder = () => (
  <Placeholder type="rect" loading className="!w-full !h-[58px]" />
);

export default PDPShopTabsBarPlaceholder;
